import { render, staticRenderFns } from "./FavoriteCard.vue?vue&type=template&id=05e8b8ca&scoped=true&"
import script from "./FavoriteCard.vue?vue&type=script&lang=js&"
export * from "./FavoriteCard.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteCard.vue?vue&type=style&index=0&id=05e8b8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8b8ca",
  null
  
)

export default component.exports